import ArticleCard from "@/components/ArticleCard";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3.5rem 0;
`;

export const Article = styled(ArticleCard)`
  margin-bottom: 5rem;
`;
